import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeatherCardComponent } from './weather-card.component';
import { MeasuresModule } from 'ngx-zcs-components';
import { IonicModule } from '@ionic/angular';

import { WeatherIconModule } from '../weather-icon/weather-icon.module';

@NgModule({
  declarations: [
    WeatherCardComponent,
  ],
  imports: [
    CommonModule,
    MeasuresModule,
    IonicModule,
    WeatherIconModule,
  ],
  exports: [
    WeatherCardComponent,
  ],
})
export class WeatherCardModule { }
